import React, { useState } from 'react';
import { Formik, Form, FieldArray } from 'formik';
import * as Yup from 'yup';
import Select from 'react-select';
import { useTranslation } from 'react-i18next';
import { GoogleMap, LoadScript, Marker } from '@react-google-maps/api';
import { useAreaData, useTypeMasterData } from '../../API_Master/GetAPI';
import { allowOnlyNumbers, notifyError } from '../../HelperMethods';
import { useAddVenderRegistration, useRemoveShopHelperDetails } from '../../API_Master/MutateAPI';
import Cookies from "js-cookie";
import { NIGHT_EYE_IMG_URL } from '../../Process';
import Swal from 'sweetalert2';
import LocationAutoFiller from '../LocationAutoFiller';
import RegistrationAddressFiller from '../RegistrationAddressFiller';
import FormLanguageSync from '../FormLanguageSync';
import ShopPhotoUpload from './ShopPhotoUpload';
import FullScreenLoader from '../FullScreenLoader';

const RegistrationDetails = ({ nextStep, shopDetailsData }) => {
  const { t } = useTranslation();
  const { mutate: removeShopHelperDetails, isLoading: removingTireMaster } = useRemoveShopHelperDetails();
  const { data: typeMasterData = [] } = useTypeMasterData("StallType");
  const { data: areaData = [] } = useAreaData(Cookies.get("NIGHT_EYE_CITY_ID") || "" , Cookies.get("NIGHT_EYE_ZONE_ID") || "" ,Cookies.get("NIGHT_EYE_POLICE_STATION_ID")  || "",Cookies.get("NIGHT_EYE_AREA_ID") || "") ;
  const { data: helperRoleData = [] } = useTypeMasterData("HelperRole");
  const { mutate: addVenderRegistration, isPending: addingVenderRegistration } = useAddVenderRegistration();
  const [showMapModal, setShowMapModal] = useState(false);

  // Default center on Surat, Gujarat
  const suratCenter = { lat: 21.170240, lng: 72.831062 };

  const mapContainerStyle = {
    width: '100%',
    height: '100%',
  };

  // Stall Type Options
  const stallTypeOptions = typeMasterData?.map(ele => ({
    value: ele?.TypeMasterID,
    label: ele?.Type
  }));

  const helperRowOptions = helperRoleData?.map(ele => ({
    value: ele?.TypeMasterID,
    label: ele?.Type
  }));

  const areaOptions = areaData?.map(ele => ({
    value: ele?.AreaID,
    label: ele?.AreaName
  }));

  const loginDetails =
    shopDetailsData?.[0]?.ShopEmployeeLoginDetail?.filter(
      x => x.IsActive && !x.IsDelete
    ) || [];

  // Step 1: bind by type
  let LoginShopUserID1 = loginDetails.find(x => x.Type === "MobileNo1")?.LoginUserID || "";
  let LoginShopUserID2 = loginDetails.find(x => x.Type === "MobileNo2")?.LoginUserID || "";
  let LoginShopUserID3 = loginDetails.find(x => x.Type === "MobileNo3")?.LoginUserID || "";


  // Step 2: fallback sequence fill
  // const usedIds = new Set([LoginShopUserID1, LoginShopUserID2, LoginShopUserID3].filter(Boolean));
  // const remaining = loginDetails.filter(x => !usedIds.has(x.LoginUserID));

  // if (!LoginShopUserID1 && remaining.length) LoginShopUserID1 = remaining.shift().LoginUserID;
  // if (!LoginShopUserID2 && remaining.length) LoginShopUserID2 = remaining.shift().LoginUserID;
  // if (!LoginShopUserID3 && remaining.length) LoginShopUserID3 = remaining.shift().LoginUserID;

  // const payload = {
  //   LoginShopUserID1,
  //   LoginShopUserID2,
  //   LoginShopUserID3
  // };

  const initialValues = {
    UserID: '',
    AreaID: shopDetailsData?.[0]?.AreaID || '',
    AreaLabel: shopDetailsData?.[0]?.AreaName || '',
    OtherArea: shopDetailsData?.[0]?.OtherArea || "",
    StallType: shopDetailsData?.[0]?.TypeMasterID || '',
    StallTypeLabel: shopDetailsData?.[0]?.Type || "",
    OtherTypeMasterName: shopDetailsData?.[0]?.OtherTypeMasterName || '',
    ShopName: shopDetailsData?.[0]?.ShopName || '',
    ShopMobileNo1: shopDetailsData?.[0]?.ShopMobileNo1 || '',
    ShopMobileNo2: shopDetailsData?.[0]?.ShopMobileNo2 || '',
    ShopMobileNo3: shopDetailsData?.[0]?.ShopMobileNo3 || '',

    // ── New fields for different login numbers ───────────────────────────────
    UseDifferentLoginNumbers: shopDetailsData?.[0]?.IsShopOpenByOtherEmployee || false,
    LoginMobileNo1: shopDetailsData?.[0]?.ShopMobileNo1 || '',
    LoginMobileNo2: shopDetailsData?.[0]?.ShopMobileNo2 || '',
    LoginMobileNo3: shopDetailsData?.[0]?.ShopMobileNo3 || '',
    // ────────────────────────────────────────────────────────────────────────

    // LoginShopUserID1: shopDetailsData?.[0]?.ShopEmployeeLoginDetail?.[0]?.LoginUserID || "",
    // LoginShopUserID2: shopDetailsData?.[0]?.ShopEmployeeLoginDetail?.[1]?.LoginUserID || "",
    // LoginShopUserID3: shopDetailsData?.[0]?.ShopEmployeeLoginDetail?.[2]?.LoginUserID || "",

    LoginShopUserID1: LoginShopUserID1,
    LoginShopUserID2: LoginShopUserID2,
    LoginShopUserID3: LoginShopUserID3,


    Address: shopDetailsData?.[0]?.Address || '',
    Latitude: shopDetailsData?.[0]?.Latitude || '',
    Longitude: shopDetailsData?.[0]?.Longitude || '',
    ShopOpenTime: shopDetailsData?.[0]?.ShopOpenTime || '',
    ShopCloseTime: shopDetailsData?.[0]?.ShopCloseTime || '',
    helpers: shopDetailsData?.[0]?.ShopHelperDetail?.map(ele => ({
      ShopHelperDetailID: ele?.ShopHelperDetailID || "",
      HelperName: ele.HelperName || '',
      HelperMobileNo: ele.HelperMobileNo || '',
      HelperRole: ele.HelperRole || ''
    })) || [{ HelperName: "", HelperMobileNo: "", HelperRole: "" }],
    ShopImage: null,
    oldShopImage: shopDetailsData?.[0]?.ShopImage || '',
    
  };

  const validationSchema = Yup.object({
    ShopName: Yup.string()
      .required(t('shopName') + ' ' + t('isRequired'))
      .min(3, t('minimumCharacters')),

    AreaID: Yup.number().required(t('area') + ' ' + t('isRequired')),

    StallType: Yup.string().required(t('stallType') + ' ' + t('isRequired')),

    OtherTypeMasterName: Yup.string().when('StallTypeLabel', {
      is: 'Other',
      then: (schema) => schema.required(t('otherTypeName') + ' ' + t('isRequired')).min(3, t('minimumCharacters')),
      otherwise: (schema) => schema.notRequired(),
    }),

    OtherArea: Yup.string().when('AreaLabel', {
      is: 'Other',
      then: (schema) => schema.required(t('otherArea') + ' ' + t('isRequired')).min(3, t('minimumCharacters')),
      otherwise: (schema) => schema.notRequired(),
    }),

    // ── Conditional mobile number validation ─────────────────────────────────
    ShopMobileNo1: Yup.string().when('UseDifferentLoginNumbers', {
      is: false,
      then: (schema) =>
        schema
          .matches(/^[\d\s-]{10,15}$/, t('invalidMobile'))
          .required(t('primaryMobile') + ' ' + t('isRequired')),
      otherwise: (schema) => schema.notRequired(),
    }),

    LoginMobileNo1: Yup.string().when('UseDifferentLoginNumbers', {
      is: true,
      then: (schema) =>
        schema
          .matches(/^[\d\s-]{10,15}$/, t('invalidMobile'))
          .required('લોગિન માટે પ્રાથમિક મોબાઈલ નંબર જરૂરી છે'),
      otherwise: (schema) => schema.notRequired(),
    }),

    Address: Yup.string()
      .required(t('registeredAddress') + ' ' + t('isRequired'))
      .min(10, t('addressTooShort')),

    Latitude: Yup.string()
      .matches(/^[-]?[0-9]*\.?[0-9]+$/, t('invalidLatitude'))
      .required(t('latitude') + ' ' + t('isRequired')),

    Longitude: Yup.string()
      .matches(/^[-]?[0-9]*\.?[0-9]+$/, t('invalidLongitude'))
      .required(t('longitude') + ' ' + t('isRequired')),

    ShopOpenTime: Yup.string().required(t('startTime') + ' ' + t('isRequired')),

    ShopCloseTime: Yup.string()
      .required(t('endTime') + ' ' + t('isRequired'))
      .test('is-after', t('endTime') + ' must be after ' + t('startTime'), function (value) {
        const { ShopOpenTime } = this.parent;
        return !ShopOpenTime || !value || value > ShopOpenTime;
      }),

    ShopImage: Yup.mixed().when('oldShopImage', {
      is: (oldShopImage) => !oldShopImage || oldShopImage.trim() === '',
      then: (schema) =>
        schema
          .required(t('shopImage') + ' ' + t('isRequired'))
          .test('fileSize', t('fileTooLarge'), (value) => !value || value.size <= 5000000)
          .test('fileType', t('invalidFileType'), (value) =>
            !value || ['image/jpg', 'image/jpeg', 'image/png', 'image/gif'].includes(value.type)
          ),
      otherwise: (schema) =>
        schema
          .nullable()
          .notRequired()
          .test('fileSize', t('fileTooLarge'), (value) => !value || value.size <= 5000000)
          .test('fileType', t('invalidFileType'), (value) =>
            !value || ['image/jpg', 'image/jpeg', 'image/png', 'image/gif'].includes(value.type)
          ),
    }),

    helpers: Yup.array().of(
      Yup.object().shape({
        HelperName: Yup.string().test('required-if-others', t('fullName') + ' ' + t('isRequired'), function (value) {
          const { HelperMobileNo, HelperRole } = this.parent;
          return !HelperMobileNo && !HelperRole ? true : !!value && value.trim().length >= 2;
        }),
        HelperMobileNo: Yup.string()
          .matches(/^[\d\s-]{10,15}$/, t('invalidMobile'))
          .test('required-if-others', t('mobileNumber') + ' ' + t('isRequired'), function (value) {
            const { HelperName, HelperRole } = this.parent;
            return !HelperName && !HelperRole ? true : !!value;
          }),
        HelperRole: Yup.string().test('required-if-others', t('role') + ' ' + t('isRequired'), function (value) {
          const { HelperName, HelperMobileNo } = this.parent;
          return !HelperName && !HelperMobileNo ? true : !!value;
        }),
      })
    ),
  });

  const inputBaseClasses = 'w-full h-12 px-4 rounded-lg bg-slate-50 dark:bg-slate-800 text-[#0d141b] dark:text-white placeholder:text-slate-400 transition-all outline-none';
  const inputFocusClasses = 'focus:ring-2 focus:ring-primary/20 focus:border-primary';
  const inputErrorClasses = 'border-red-500';
  const inputNormalBorder = 'border border-slate-300 dark:border-slate-600';

  const selectStyles = {
    control: (provided, state) => ({
      ...provided,
      height: '48px',
      minHeight: '48px',
      backgroundColor: 'rgb(241 245 249)',
      borderColor: state.isFocused ? '#3B82F6' : 'rgb(203 213 225)',
      boxShadow: state.isFocused ? '0 0 0 1px #3B82F6' : 'none',
      borderRadius: '0.5rem',
      '&:hover': { borderColor: '#3B82F6' },
    }),
    valueContainer: (provided) => ({ ...provided, padding: '0 16px' }),
    singleValue: (provided) => ({ ...provided, color: '#0D141B' }),
    placeholder: (provided) => ({ ...provided, color: '#94A3B8' }),
  };

  const darkSelectStyles = {
    ...selectStyles,
    control: (provided, state) => ({
      ...provided,
      backgroundColor: '#1E293B',
      borderColor: state.isFocused ? '#3B82F6' : '#334155',
      '&:hover': { borderColor: '#3B82F6' },
    }),
    singleValue: (provided) => ({ ...provided, color: '#F8FAFC' }),
    placeholder: (provided) => ({ ...provided, color: '#94A3B8' }),
  };

  return (
    <>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
          //  enableReinitialize={true}  
        onSubmit={(values, { setSubmitting }) => {
          const payload = {
            UserID: Cookies.get("VENDER_NIGHT_EYE_USER_ID") || "",
            ShopDetailID: Cookies.get("NIGHT_EYE_SHOP_DETAIL_ID") || "",
            AreaID: values.AreaID || "",
            OtherArea: values.AreaLabel.toLowerCase() === "other" ? values?.OtherArea : "",
            TypeMasterID: values.StallType || "",
            OtherTypeMasterName: values.StallTypeLabel?.toLowerCase() === 'other' ? values?.OtherTypeMasterName : "",
            ShopName: values.ShopName || "",

            // ── Mobile numbers logic ────────────────────────────────────────────
            LoginShopUserID1: values?.LoginShopUserID1 || "",
            LoginShopUserID2: values?.LoginShopUserID2 || "",
            LoginShopUserID3: values?.LoginShopUserID3 || "",

            ShopMobileNo1: values.UseDifferentLoginNumbers ? values.LoginMobileNo1 || "" : values.ShopMobileNo1 || "",
            ShopMobileNo2: values.UseDifferentLoginNumbers ? values.LoginMobileNo2 || "" : values.ShopMobileNo2 || "",
            ShopMobileNo3: values.UseDifferentLoginNumbers ? values.LoginMobileNo3 || "" : values.ShopMobileNo3 || "",
            // ────────────────────────────────────────────────────────────────────
            IsShopOpenByOtherEmployee: values.UseDifferentLoginNumbers,
            Address: values.Address || "",
            Latitude: values.Latitude || "",
            Longitude: values.Longitude || "",
            ShopOpenTime: values.ShopOpenTime || "",
            ShopCloseTime: values.ShopCloseTime || "",
            CreatedByUserID: Cookies.get("NIGHT_EYE_USER_ID") || "",

            HelperDetails: JSON.stringify(
              values.helpers
                .filter((h) => h.HelperName || h.HelperMobileNo || h.HelperRole)
                .map((h) => ({
                  ShopHelperDetailID: h?.ShopHelperDetailID || "",
                  HelperRole: h.HelperRole || "",
                  HelperName: h.HelperName || "",
                  HelperMobileNo: h.HelperMobileNo || "",
                }))
            ),
            ShopImage: values.ShopImage || "",
            OldShopImage: values?.oldShopImage || ""
          };

          addVenderRegistration(payload, {
            onSuccess: (res) => {
              if (res?.status === true) {
                Cookies.set("NIGHT_EYE_SHOP_DETAIL_ID", res?.data?.[0]?.ShopDetailID || "");
                Cookies.set("IsStep1Completed", true);
                nextStep();
              } else {
                notifyError(res?.message || "Data Not Inserted");
              }
            },
            onError: () => {
              notifyError("Failed to Insert User");
            }
          });
        }}
      >
        {({ values, touched, errors, setFieldValue, setValues, handleBlur, isSubmitting }) => (
          <>
            <FormLanguageSync />

            <Form className="bg-white dark:bg-[#1A2633] rounded-xl shadow-sm border border-slate-200 dark:border-slate-700 overflow-hidden">
              {/* Basic Shop Information */}
              <div className="p-6 md:p-8 border-b border-slate-100 dark:border-slate-700">
                <div className="flex items-center gap-3 mb-6">
                  <div className="p-2 bg-primary/10 rounded-lg text-primary">
                    <span className="material-symbols-outlined">storefront</span>
                  </div>
                  <h3 className="text-lg font-bold text-[#0d141b] dark:text-white">{t('basicShopInfo')}</h3>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  {/* Shop Name */}
                  <div className="flex flex-col gap-2">
                    <label className="text-xs font-bold text-[#0d141b] dark:text-slate-300">
                      {t('shopName')} <span className="text-red-700">*</span>
                    </label>
                    <input
                      name="ShopName"
                      value={values.ShopName}
                      onChange={(e) => setFieldValue('ShopName', e.target.value)}
                      onBlur={handleBlur}
                      className={`${inputBaseClasses} ${inputFocusClasses} ${touched.ShopName && errors.ShopName ? inputErrorClasses : inputNormalBorder}`}
                      placeholder={t('shopName')}
                      type="text"
                    />
                    {touched.ShopName && errors.ShopName && (
                      <p className="text-red-700 text-xs font-bold">{errors.ShopName}</p>
                    )}
                  </div>

                  {/* Stall Type */}
                  <div className="flex flex-col gap-2">
                    <label className="text-xs font-bold text-[#0d141b] dark:text-slate-300">
                      {t('stallType')} <span className="text-red-700">*</span>
                    </label>
                    <Select
                      options={stallTypeOptions}
                      value={stallTypeOptions.find((opt) => opt.value === values.StallType) || null}
                      onChange={(opt) => {
                        setValues((prev) => ({
                          ...prev,
                          OtherTypeMasterName: opt?.value !== 'other' ? "" : prev?.OtherTypeMasterName,
                          StallTypeLabel: opt ? opt.label : '',
                          StallType: opt ? opt.value : '',
                        }));
                      }}
                      placeholder={t('stallType')}
                      styles={document.body.classList.contains('dark') ? darkSelectStyles : selectStyles}
                      classNamePrefix="react-select"
                    />
                    {touched.StallType && errors.StallType && (
                      <p className="text-red-700 text-xs font-bold">{errors.StallType}</p>
                    )}
                  </div>

                  {values.StallTypeLabel?.toLowerCase() === 'other' && (
                    <div className="flex flex-col gap-2">
                      <label className="text-xs font-bold text-[#0d141b] dark:text-slate-300">
                        {t('otherTypeName')} <span className="text-red-700">*</span>
                      </label>
                      <input
                        name="OtherTypeMasterName"
                        value={values.OtherTypeMasterName}
                        onChange={(e) => setFieldValue('OtherTypeMasterName', e.target.value)}
                        className={`${inputBaseClasses} ${inputFocusClasses} ${touched.OtherTypeMasterName && errors.OtherTypeMasterName ? inputErrorClasses : inputNormalBorder}`}
                        placeholder={t('otherTypeName')}
                      />
                      {touched.OtherTypeMasterName && errors.OtherTypeMasterName && (
                        <p className="text-red-700 text-xs font-bold">{errors.OtherTypeMasterName}</p>
                      )}
                    </div>
                  )}

                  {/* Area */}
                  <div className="flex flex-col gap-2">
                    <label className="text-xs font-bold text-[#0d141b] dark:text-slate-300">
                      {t('area')} <span className="text-red-700">*</span>
                    </label>
                    <Select
                      options={areaOptions}
                      value={areaOptions.find((opt) => opt.value === values.AreaID) || null}
                      onChange={(opt) => {
                        setValues((prev) => ({
                          ...prev,
                          AreaLabel: opt ? opt.label : '',
                          AreaID: opt ? opt.value : ''
                        }));
                      }}
                      placeholder={t('area')}
                      styles={document.body.classList.contains('dark') ? darkSelectStyles : selectStyles}
                      classNamePrefix="react-select"
                    />
                    {touched.AreaID && errors.AreaID && (
                      <p className="text-red-700 text-xs font-bold">{errors.AreaID}</p>
                    )}
                  </div>

                  {values.AreaLabel?.toLowerCase() === 'other' && (
                    <div className="flex flex-col gap-2">
                      <label className="text-xs font-bold text-[#0d141b] dark:text-slate-300">
                        {t('otherArea')} <span className="text-red-700">*</span>
                      </label>
                      <input
                        name="OtherArea"
                        value={values.OtherArea}
                        onChange={(e) => setFieldValue('OtherArea', e.target.value)}
                        className={`${inputBaseClasses} ${inputFocusClasses} ${touched.OtherArea && errors.OtherArea ? inputErrorClasses : inputNormalBorder}`}
                        placeholder={t('otherArea')}
                      />
                      {touched.OtherArea && errors.OtherArea && (
                        <p className="text-red-700 text-xs font-bold">{errors.OtherArea}</p>
                      )}
                    </div>
                  )}

                  {/* ── Checkbox + Conditional Mobile Numbers ──────────────────────── */}
                  <div className="col-span-1 md:col-span-2">
                    <div className="flex items-start gap-3 py-2">
                      <input
                        type="checkbox"
                        id="useDifferentLoginNumbers"
                        checked={values.UseDifferentLoginNumbers}
                        onChange={(e) => {
                          setFieldValue('UseDifferentLoginNumbers', e.target.checked);
                          // Optional: clear opposite fields when switching
                          if (e.target.checked) {
                            setFieldValue('ShopMobileNo1', '');
                            setFieldValue('ShopMobileNo2', '');
                            setFieldValue('ShopMobileNo3', '');
                          } else {
                            setFieldValue('LoginMobileNo1', '');
                            setFieldValue('LoginMobileNo2', '');
                            setFieldValue('LoginMobileNo3', '');
                          }
                        }}
                        className="mt-1 h-5 w-5 rounded border-slate-300 text-primary focus:ring-primary"
                      />
                      <label
                        htmlFor="useDifferentLoginNumbers"
                        className="text-sm text-slate-700 dark:text-slate-300 cursor-pointer select-none"
                      >
                        {t('useDifferentLoginNumbersLabel')}
                      </label>
                    </div>
                  </div>

                  {/* Normal Shop Mobile Numbers - shown when checkbox is NOT checked */}
                  {!values.UseDifferentLoginNumbers && (
                    <>
                      <div className="flex flex-col gap-2">
                        <label className="text-xs font-bold text-[#0d141b] dark:text-slate-300">
                          {t('primaryMobile')} <span className="text-red-700">*</span>
                        </label>
                        <input
                          name="ShopMobileNo1"
                          value={values.ShopMobileNo1}
                          onKeyDown={allowOnlyNumbers}
                          onPaste={allowOnlyNumbers}
                          maxLength={10}
                          onChange={(e) => setFieldValue('ShopMobileNo1', e.target.value)}
                          onBlur={handleBlur}
                          className={`${inputBaseClasses} ${inputFocusClasses} ${touched.ShopMobileNo1 && errors.ShopMobileNo1 ? inputErrorClasses : inputNormalBorder}`}
                          placeholder={t('mobileNumber')}
                          type="tel"
                        />
                        {touched.ShopMobileNo1 && errors.ShopMobileNo1 && (
                          <p className="text-red-700 text-xs font-bold">{errors.ShopMobileNo1}</p>
                        )}
                      </div>

                      <div className="flex flex-col gap-2">
                        <label className="text-xs font-bold text-[#0d141b] dark:text-slate-300">{t('mobileNo2')}</label>
                        <input
                          name="ShopMobileNo2"
                          value={values.ShopMobileNo2}
                          onKeyDown={allowOnlyNumbers}
                          onPaste={allowOnlyNumbers}
                          maxLength={10}
                          onChange={(e) => setFieldValue('ShopMobileNo2', e.target.value)}
                          className={`${inputBaseClasses} ${inputFocusClasses} ${inputNormalBorder}`}
                          placeholder={t('mobileNumber')}
                          type="tel"
                        />
                      </div>

                      <div className="flex flex-col gap-2">
                        <label className="text-xs font-bold text-[#0d141b] dark:text-slate-300">{t('mobileNo3')}</label>
                        <input
                          name="ShopMobileNo3"
                          value={values.ShopMobileNo3}
                          onKeyDown={allowOnlyNumbers}
                          onPaste={allowOnlyNumbers}
                          maxLength={10}
                          onChange={(e) => setFieldValue('ShopMobileNo3', e.target.value)}
                          className={`${inputBaseClasses} ${inputFocusClasses} ${inputNormalBorder}`}
                          placeholder={t('mobileNumber')}
                          type="tel"
                        />
                      </div>
                    </>
                  )}

                  {/* Login Mobile Numbers - shown when checkbox IS checked */}
                  {values.UseDifferentLoginNumbers && (
                    <>
                      <div className="flex flex-col gap-2">
                        <label className="text-xs font-bold text-[#0d141b] dark:text-slate-300">
                          {t('loginPrimaryMobile')} <span className="text-red-700">*</span>
                        </label>
                        <input
                          name="LoginMobileNo1"
                          value={values.LoginMobileNo1}
                          onKeyDown={allowOnlyNumbers}
                          onPaste={allowOnlyNumbers}
                          maxLength={10}
                          onChange={(e) => setFieldValue('LoginMobileNo1', e.target.value)}
                          onBlur={handleBlur}
                          className={`${inputBaseClasses} ${inputFocusClasses} ${touched.LoginMobileNo1 && errors.LoginMobileNo1 ? inputErrorClasses : inputNormalBorder}`}
                          placeholder={t('mobileNumber')}
                          type="tel"
                        />
                        {touched.LoginMobileNo1 && errors.LoginMobileNo1 && (
                          <p className="text-red-700 text-xs font-bold">{errors.LoginMobileNo1}</p>
                        )}
                      </div>

                      <div className="flex flex-col gap-2">
                        <label className="text-xs font-bold text-[#0d141b] dark:text-slate-300">
                          {t('loginMobileNo2')}
                        </label>
                        <input
                          name="LoginMobileNo2"
                          value={values.LoginMobileNo2}
                          onKeyDown={allowOnlyNumbers}
                          onPaste={allowOnlyNumbers}
                          maxLength={10}
                          onChange={(e) => setFieldValue('LoginMobileNo2', e.target.value)}
                          className={`${inputBaseClasses} ${inputFocusClasses} ${inputNormalBorder}`}
                          placeholder={t('mobileNumber')}
                          type="tel"
                        />
                      </div>

                      <div className="flex flex-col gap-2">
                        <label className="text-xs font-bold text-[#0d141b] dark:text-slate-300">
                          {t('loginMobileNo3')}
                        </label>
                        <input
                          name="LoginMobileNo3"
                          value={values.LoginMobileNo3}
                          onKeyDown={allowOnlyNumbers}
                          onPaste={allowOnlyNumbers}
                          maxLength={10}
                          onChange={(e) => setFieldValue('LoginMobileNo3', e.target.value)}
                          className={`${inputBaseClasses} ${inputFocusClasses} ${inputNormalBorder}`}
                          placeholder={t('mobileNumber')}
                          type="tel"
                        />
                      </div>
                    </>
                  )}
                  {/* ───────────────────────────────────────────────────────────────── */}

                  {/* Shop Image */}
                  <div className="col-span-1 md:col-span-2 flex flex-col gap-2">
                    <ShopPhotoUpload />
                  </div>
                </div>
              </div>
              <RegistrationAddressFiller />
              <div className="p-6 md:p-8 border-b border-slate-100 dark:border-slate-700">
                <div className="flex items-center gap-3 mb-6">
                  <div className="p-2 bg-primary/10 rounded-lg text-primary">
                    <span className="material-symbols-outlined">schedule</span>
                  </div>
                  <h3 className="text-lg font-bold text-[#0d141b] dark:text-white">{t('operatingHours')}</h3>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div className="flex flex-col gap-2">
                    <label className="text-xs font-bold text-[#0d141b] dark:text-slate-300">
                      {t('startTime')} <span className="text-red-700">*</span>
                    </label>
                    <input
                      name="ShopOpenTime"
                      value={values.ShopOpenTime}
                      onChange={(e) => setFieldValue('ShopOpenTime', e.target.value)}
                      onBlur={handleBlur}
                      className={`${inputBaseClasses} ${inputFocusClasses} ${touched.ShopOpenTime && errors.ShopOpenTime ? inputErrorClasses : inputNormalBorder}`}
                      type="time"
                    />
                    {touched.ShopOpenTime && errors.ShopOpenTime && <p className="text-red-700 text-xs font-bold">{errors.ShopOpenTime}</p>}
                  </div>

                  <div className="flex flex-col gap-2">
                    <label className="text-xs font-bold text-[#0d141b] dark:text-slate-300">
                      {t('endTime')} <span className="text-red-700">*</span>
                    </label>
                    <input
                      name="ShopCloseTime"
                      value={values.ShopCloseTime}
                      onChange={(e) => setFieldValue('ShopCloseTime', e.target.value)}
                      onBlur={handleBlur}
                      className={`${inputBaseClasses} ${inputFocusClasses} ${touched.ShopCloseTime && errors.ShopCloseTime ? inputErrorClasses : inputNormalBorder}`}
                      type="time"
                    />
                    {touched.ShopCloseTime && errors.ShopCloseTime && <p className="text-red-700 text-xs font-bold">{errors.ShopCloseTime}</p>}
                  </div>
                </div>
              </div>
              <div className="p-6 md:p-8 bg-slate-50/50 dark:bg-slate-800/20">
                <div className="flex items-center justify-between mb-6">
                  <div className="flex items-center gap-3">
                    <div className="p-2 bg-primary/10 rounded-lg text-primary">
                      <span className="material-symbols-outlined">group</span>
                    </div>
                    <div>
                      <h3 className="text-lg font-bold text-[#0d141b] dark:text-white">{t('shopHelpers')}</h3>
                      <p className="text-xs text-slate-500 dark:text-slate-400">{t('addHelper')}</p>
                    </div>
                  </div>
                </div>

                <FieldArray name="helpers">
                  {({ push, remove }) => {
                    // Check if any existing helper has errors or incomplete required data
                    const hasHelperErrors = values.helpers.some((helper, index) => {
                      const hasAnyField = helper.HelperName || helper.HelperMobileNo || helper.HelperRole;
                      if (!hasAnyField) return false;

                      const errorsForIndex = errors.helpers?.[index];
                      return (
                        errorsForIndex?.HelperName ||
                        errorsForIndex?.HelperMobileNo ||
                        errorsForIndex?.HelperRole ||
                        !helper.HelperName?.trim() ||
                        !helper.HelperMobileNo?.trim() ||
                        !helper.HelperRole
                      );
                    });

                    const canAddNewHelper = !hasHelperErrors && values.helpers.length < 10; // optional max limit

                    const handleDeleteHelper = async (index) => {
                      const helper = values.helpers[index];

                      // If it's a new unsaved helper (no ID), just remove immediately
                      if (!helper.ShopHelperDetailID) {
                        remove(index);
                        return;
                      }

                      // Otherwise, confirm and call API
                      const confirmAction = await Swal.fire({
                        title: t('areYouSure'),
                        text: t('deleteHelperRecord'),
                        icon: "warning",
                        showCancelButton: true,
                        confirmButtonText: t('confirm'),
                        cancelButtonText: t('cancel'),
                        confirmButtonColor: "#7367f0",
                        cancelButtonColor: "#ebebed",
                      });

                      if (!confirmAction.isConfirmed) return;

                      const payload = {
                        ShopHelperDetailID: helper.ShopHelperDetailID,
                        RemovedByUserID: Cookies.get("NIGHT_EYE_USER_ID")
                      };

                      removeShopHelperDetails(payload, {
                        onSuccess: (res) => {
                          if (res?.status === true) {
                            // toast.success(t('helperDeletedSuccess') || "Helper deleted successfully");
                            remove(index); // Now remove from form
                          } else {
                            notifyError(res?.message || "Failed to delete helper");
                          }
                        },
                        onError: () => {
                          notifyError("Failed to delete helper record");
                        }
                      });
                    };

                    return (
                      <div className="flex flex-col gap-4">
                        {values?.helpers?.map((_, index) => (
                          <div
                            key={index}
                            className="flex flex-col md:flex-row gap-4 p-4 bg-white dark:bg-[#1A2633] border border-slate-200 dark:border-slate-700 rounded-lg shadow-sm group"
                          >
                            <div className="flex-1 flex flex-col gap-1">
                              <label className="text-xs font-bold font-semibold text-slate-500 uppercase">{t('fullName')}</label>
                              <input
                                name={`helpers[${index}].HelperName`}
                                value={values.helpers[index].HelperName}
                                onChange={(e) => setFieldValue(`helpers[${index}].HelperName`, e.target.value)}
                                onBlur={handleBlur}
                                className={`${inputBaseClasses} ${inputFocusClasses} ${touched.helpers?.[index]?.HelperName && errors.helpers?.[index]?.HelperName
                                  ? inputErrorClasses
                                  : inputNormalBorder
                                  }`}
                                placeholder={t('fullName')}
                                type="text"
                              />
                              {touched.helpers?.[index]?.HelperName && errors.helpers?.[index]?.HelperName && (
                                <p className="text-red-700 text-xs font-bold">{errors.helpers[index].HelperName}</p>
                              )}
                            </div>

                            <div className="flex-1 flex flex-col gap-1">
                              <label className="text-xs font-bold font-semibold text-slate-500 uppercase">{t('mobileNumber')}</label>
                              <input
                                name={`helpers[${index}].HelperMobileNo`}
                                value={values.helpers[index].HelperMobileNo}
                                onChange={(e) => setFieldValue(`helpers[${index}].HelperMobileNo`, e.target.value)}
                                onBlur={handleBlur}
                                maxLength={10}
                                onKeyDown={allowOnlyNumbers}
                                onPaste={allowOnlyNumbers}
                                className={`${inputBaseClasses} ${inputFocusClasses} ${touched.helpers?.[index]?.HelperMobileNo && errors.helpers?.[index]?.HelperMobileNo
                                  ? inputErrorClasses
                                  : inputNormalBorder
                                  }`}
                                placeholder={t('mobileNumber')}
                                type="tel"
                              />
                              {touched.helpers?.[index]?.HelperMobileNo && errors.helpers?.[index]?.HelperMobileNo && (
                                <p className="text-red-700 text-xs font-bold">{errors.helpers[index].HelperMobileNo}</p>
                              )}
                            </div>

                            <div className="flex-1 flex flex-col gap-1">
                              <label className="text-xs font-bold font-semibold text-slate-500 uppercase">{t('role')}</label>
                              <Select
                                options={helperRowOptions}
                                value={helperRowOptions.find((opt) => opt.value === values.helpers[index].HelperRole) || null}
                                onChange={(opt) => setFieldValue(`helpers[${index}].HelperRole`, opt ? opt.value : '')}
                                onBlur={() => handleBlur({ target: { name: `helpers[${index}].HelperRole` } })}
                                placeholder={t('role')}
                                isSearchable={false}
                                styles={document.body.classList.contains('dark') ? darkSelectStyles : selectStyles}
                                classNamePrefix="react-select"
                              />
                              {touched.helpers?.[index]?.HelperRole && errors.helpers?.[index]?.HelperRole && (
                                <p className="text-red-700 text-xs font-bold">{errors.helpers[index].HelperRole}</p>
                              )}
                            </div>

                            {values?.helpers?.length > 1 && <div className="flex items-end pb-1">
                              <button
                                type="button"
                                onClick={() => handleDeleteHelper(index)}
                                className="text-slate-400 hover:text-red-700 transition-colors p-1 rounded-md hover:bg-red-50 dark:hover:bg-red-900/20"
                              >
                                <span className="material-symbols-outlined">delete</span>
                              </button>
                            </div>}
                          </div>
                        ))}

                        <div className="flex gap-4">
                          <button
                            type="button"
                            onClick={() => push({ HelperName: '', HelperMobileNo: '', HelperRole: '', ShopHelperDetailID: '' })}
                            disabled={!canAddNewHelper || addingVenderRegistration || removingTireMaster}
                            className={`
                hidden sm:flex items-center gap-2 font-medium transition-colors
                ${canAddNewHelper
                                ? 'text-primary hover:text-blue-600'
                                : 'text-slate-400 cursor-not-allowed'
                              }
              `}
                          >
                            <span className="material-symbols-outlined text-[20px]">add_circle</span>
                            {t('addHelper')}
                          </button>

                          <button
                            type="button"
                            onClick={() => push({ HelperName: '', HelperMobileNo: '', HelperRole: '', ShopHelperDetailID: '' })}
                            disabled={!canAddNewHelper || addingVenderRegistration || removingTireMaster}
                            className={`
                sm:hidden w-full py-3 border rounded-lg font-medium flex items-center justify-center gap-2 transition-colors
                ${canAddNewHelper
                                ? 'border-dashed border-primary/30 text-primary hover:bg-primary/5'
                                : 'border-slate-300 dark:border-slate-600 text-slate-400 cursor-not-allowed'
                              }
              `}
                          >
                            <span className="material-symbols-outlined">add</span>
                            {t('addHelper')}
                          </button>
                        </div>

                        {/* Optional helper text */}
                        {!canAddNewHelper && values.helpers.some(h => h.HelperName || h.HelperMobileNo || h.HelperRole) && (
                          <p className="text-amber-600 text-xs mt-2">
                            {t('completeCurrentHelpersBeforeAdding')}
                          </p>
                        )}
                      </div>
                    );
                  }}
                </FieldArray>
              </div>

              {/* Form Buttons */}
              <div className="p-6 md:p-8 border-t border-slate-200 dark:border-slate-700 flex flex-col-reverse md:flex-row justify-end items-center gap-4 bg-white dark:bg-[#1A2633]">
                {/* <button
                  type="button"
                  className="w-full md:w-auto px-6 py-3 rounded-lg border border-slate-300 dark:border-slate-600 text-slate-700 dark:text-slate-300 font-medium hover:bg-slate-50 dark:hover:bg-slate-700 transition-colors"
                >
                  {t('saveDraft')}
                </button> */}

                <button
                  type="submit"
                  disabled={addingVenderRegistration}
                  className="w-full md:w-auto px-8 py-3 rounded-lg bg-primary text-white font-bold shadow-lg shadow-primary/30 hover:bg-blue-600 transition-all flex items-center justify-center gap-2 disabled:opacity-70"
                >
                  {t('next')}
                  <span className="material-symbols-outlined text-[20px]">arrow_forward</span>
                </button>
              </div>

              {/* Operating Hours, Helpers, Buttons - unchanged */}
              {/* ... (same as previous full code) ... */}

            </Form>
            {showMapModal && (
              <div className="fixed inset-0 bg-black bg-opacity-70 z-50 flex items-center justify-center p-4">
                <div className="bg-white dark:bg-[#1A2633] rounded-xl shadow-2xl w-full max-w-6xl h-[90vh] flex flex-col">
                  <div className="p-4 border-b border-slate-200 dark:border-slate-700 flex justify-between items-center">
                    <h2 className="text-xl font-bold text-[#0d141b] dark:text-white">{t('selectOnMap')}</h2>
                    <button onClick={() => setShowMapModal(false)} className="text-slate-500 hover:text-red-700 transition-colors">
                      <span className="material-symbols-outlined text-3xl">close</span>
                    </button>
                  </div>
                  <div className="flex-1">
                    <LoadScript googleMapsApiKey="AIzaSyA8Io_sD3d5uTz6ZTj4FKae_I7mdBVjX9o">
                      <GoogleMap
                        mapContainerStyle={mapContainerStyle}
                        center={
                          values.Latitude && values.Longitude
                            ? { lat: parseFloat(values.Latitude), lng: parseFloat(values.Longitude) }
                            : suratCenter
                        }
                        zoom={values.Latitude && values.Longitude ? 18 : 12}
                        onClick={(e) => {
                          if (!e?.latLng || typeof window.google?.maps?.Geocoder !== 'function') {
                            console.warn('Google Maps not ready or invalid click event');
                            return;
                          }

                          const lat = e.latLng.lat();
                          const lng = e.latLng.lng();

                          // Update lat/lng immediately
                          setFieldValue('Latitude', lat.toFixed(6));
                          setFieldValue('Longitude', lng.toFixed(6));

                          // Reverse geocode to get address
                          const geocoder = new window.google.maps.Geocoder();
                          geocoder.geocode(
                            { location: { lat, lng } },
                            (results, status) => {
                              if (status === 'OK' && results[0]) {
                                // Use formatted_address (most readable)
                                const address = results[0].formatted_address;

                                // Optional: You can choose a more specific result if needed
                                // const address = results.find(r => r.types.includes('street_address'))?.formatted_address || results[0].formatted_address;

                                setFieldValue('Address', address);
                              } else {
                                console.warn('Geocoder failed:', status);
                                // Fallback: show a basic coordinate-based address
                                setFieldValue('Address', `Location at ${lat.toFixed(6)}, ${lng.toFixed(6)}`);
                              }
                            }
                          );
                        }}
                      >
                        {values.Latitude && values.Longitude && (
                          <Marker position={{ lat: parseFloat(values.Latitude), lng: parseFloat(values.Longitude) }} />
                        )}
                      </GoogleMap>
                    </LoadScript>
                  </div>
                  <div className="p-4 border-t border-slate-200 dark:border-slate-700 text-center">
                    <button
                      onClick={() => setShowMapModal(false)}
                      className="px-8 py-3 bg-primary text-white rounded-lg font-medium hover:bg-blue-600 transition-colors"
                    >
                      {t('done')}
                    </button>
                  </div>
                </div>
              </div>
            )}
            {/* Operating Hours */}

          </>
        )}
      </Formik>
      {addingVenderRegistration && <FullScreenLoader />}
    </>
  );
};

export default RegistrationDetails;